import { useEffect } from 'react';
import React from 'react';

// 640px - большинство смартфонов
const MOBILE_BREAKPOINT = 640;


export const useDeviceDetection = (): void => {
	useEffect(() => {
		const updateDeviceClass = () => {
			const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
			const isPortrait = window.matchMedia('(orientation: portrait)').matches;
			const isStandalone = window.matchMedia('(display-mode: standalone)').matches
				|| (window.navigator as any).standalone === true;
			const body = document.body;

			// Более детальные классы
			if (window.innerWidth <= 480) {
				body.classList.add('is-smartphone');
			} else {
				body.classList.remove('is-smartphone');
			}

			if (window.innerWidth <= 768) {
				body.classList.add('is-tablet');
			} else {
				body.classList.remove('is-tablet');
			}

			if (isMobile) {
				body.classList.add('is-mobile');
				body.classList.remove('is-desktop');
			} else {
				body.classList.add('is-desktop');
				body.classList.remove('is-mobile');
			}
			body.classList.toggle('is-portrait', isPortrait);
			body.classList.toggle('is-landscape', !isPortrait);
			body.classList.toggle('is-standalone', isStandalone);
		};

		let debounceTimeout : any;
		const debounce = (handler: () => void, delayMs: number) => {
			clearTimeout(debounceTimeout);
			debounceTimeout = setTimeout(handler, delayMs);
		};

		const handleUpdateClasses = ()=>{
			debounce(()=>{
				requestAnimationFrame(updateDeviceClass); //for animation
			}, 100);
		}


		handleUpdateClasses();

		window.addEventListener('resize', handleUpdateClasses);

		const mediaQuery = window.matchMedia('(orientation: portrait)');
		mediaQuery.addEventListener('change', handleUpdateClasses);

		return () => {
			window.removeEventListener('resize', handleUpdateClasses);
			mediaQuery.removeEventListener('change', handleUpdateClasses);
		};
	}, []);
};

export function DeviceClass() {
	useDeviceDetection();
	return <React.Fragment/>;
}